export const interpolate = (source: string, options: object) => {
  const pattern = /{{\s*([\w.]+?)\s*}}/g
  const replacer = (substr: string, trimmedSubstr: string) => {
    const fullPath = trimmedSubstr.split('.')
    const result = fullPath.reduce<object>((accumulator, currentValue) => {
      return accumulator[currentValue]
    }, options)
    return result?.toString() || substr
  }

  return source.replace(pattern, replacer)
}
